import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AppRoutes } from '@core';
import { catchError, from, map, Observable, switchMap, throwError } from 'rxjs';
import { AuthService } from '../../infrastructure';
import { buildFirebaseAuthError } from '../utils';

interface RegisterPayload {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
}

@Injectable({ providedIn: 'root' })
export class RegisterHandler {
  private readonly authService: AuthService = inject(AuthService);
  private readonly router: Router = inject(Router);
  private readonly translate: TranslateService = inject(TranslateService);

  handle(payload: RegisterPayload): Observable<void> {
    const displayName: string = `${payload.firstName.trim()} ${payload.lastName.trim()}`.trim();
    return from(this.authService.register(payload.email, payload.password, displayName)).pipe(
      switchMap(() => from(this.router.navigateByUrl(`/${AppRoutes.ROOT}`))),
      map(() => void 0),
      catchError((err: { code?: string; message?: string }) =>
        throwError(() => buildFirebaseAuthError(err, this.translate))
      )
    );
  }
}
